import { render, staticRenderFns } from "./TermsOfSalesComponent.vue?vue&type=template&id=4bb342b2&scoped=true"
import script from "./TermsOfSalesComponent.vue?vue&type=script&lang=js"
export * from "./TermsOfSalesComponent.vue?vue&type=script&lang=js"
import style0 from "./TermsOfSalesComponent.vue?vue&type=style&index=0&id=4bb342b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb342b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb342b2')) {
      api.createRecord('4bb342b2', component.options)
    } else {
      api.reload('4bb342b2', component.options)
    }
    module.hot.accept("./TermsOfSalesComponent.vue?vue&type=template&id=4bb342b2&scoped=true", function () {
      api.rerender('4bb342b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/terms/TermsOfSalesComponent.vue"
export default component.exports